import { Leaf, TreePine, Droplet } from "lucide-react";

export const serviceData = {
  "lawn-maintenance": {
    title: "Lawn Maintenance",
    icon: <Leaf className="w-8 h-8 text-green-600" />,
    description:
      "We provide weekly or bi-weekly mowing, edging, and reliable care that keeps your lawn healthy and clean.",
    points: [
      "Lawn Cutting",
      "Fertilization",
      "Seeding",
      "Aeration",
      "De-thatching",
      "Sod Installation",
    ],
  },
  landscaping: {
    title: "Landscaping",
    icon: <TreePine className="w-8 h-8 text-green-600" />,
    description:
      "Make your home stand out with precision mulching, stone features, and carefully sculpted pruning.",
    points: [
      "Mulching",
      "Shrub & Tree Pruning",
      "Stone Installation",
      "Yard Cleanups",
    ],
  },
  irrigation: {
    title: "Irrigation",
    icon: <Droplet className="w-8 h-8 text-green-600" />,
    description:
      "Smart irrigation means better water use, less hassle, and healthier lawns year-round.",
    points: [
      "Spring Startup",
      "Repairs & Troubleshooting",
      "Smart Controller Installs",
      "Winterizations",
    ],
  },
};
